var moment = require('moment');


function fioFull () {
    return function(value) {
      
        if(!value){
            return '--';
        }
        if(!value.MiddleName && !value.Name && !value.LastName){
            return '--';
        }
        let result = '';

        if(value.LastName){
            result = value.LastName;
        }

        if(value.Name){
            result+=' '+value.Name;
        }

        if( value.MiddleName){
            result+=' '+value.MiddleName;
        }

        return result;
    };
}
  
function gender() {
    return function(value) {
        if(!value){
            return '--';
        }
        
      return value=='male'?'Мужчина':'Женщина'
    };
}

function printableDate() {
    return function(value) {
        if(!value){
            return '--';
        }
        

        let date = moment(value);

        if(!date.isValid()){
            date = moment(value, 'DD.MM.YYYY');
        }
        if(!date.isValid()){
            return value
        }
        
      return date.format("LL")
    };
}



export { 
    fioFull, 
    gender,
    printableDate
}
  


// WEBPACK FOOTER //
// ./src/app.filters.js